





























































































































































import { TournamentEntity } from '@/api/tournament'
import { Vue, Component, Prop } from 'vue-property-decorator'
import tournamentStore from '@/modules/tournament/tournament.store'
import { getModule } from 'vuex-module-decorators'
import { getPrizeCurrency, getPrizeValue } from '@/utils/prize'
import { TranslateResult } from 'vue-i18n'
import { dateTime } from '@/utils'

// @Prop({ default: null }) relatedTournament!:

interface Prize {
  title: string | TranslateResult
  prize: string
}

@Component({
  filters: {
    dateTime
  }
})
export default class TournamentBasicInformationMobile extends Vue {
  // @Prop({ default: null }) relatedTournament!:

  tournamentModule = getModule(tournamentStore, this.$store)

  get tournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  get tournamentPrizes(): Prize[] {
    if (!this.tournament) return []
    return [
      {
        title: this.$t('TournamentDetailsOverview.Champion'),
        prize: this.tournament.prizeChampionPrize
      },
      {
        title: this.$t('TournamentDetailsOverview.1stRunnerUp'),
        prize: this.tournament.prizeFirstRunnerUpPrize
      },
      {
        title: this.$t('TournamentDetailsOverview.2ndRunnerUp'),
        prize: this.tournament.prizeSecondRunnerUpPrize
      }
    ]
  }

  getPrizeCurrency(prize: string) {
    if (!prize) return ''
    return getPrizeCurrency(prize)
  }

  getPrizeValue(prize: string) {
    if (!prize) return ''
    return getPrizeValue(prize)
  }
}
